import { combineReducers } from 'redux'
import drawer from './finalAppreciationsDrawer'
import tab from './tabs/finalAppreciations'

export default combineReducers({
  tab,
  drawer,
})
